<template>
    <div :class="{ 'survey-slider': true, invalid: display === null }" style="position: relative; margin-bottom: 40px">
        <svg
            :viewBox="`0 0 ${width} ${height}`"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            :style="`width:${width}px;height:${height}px;position:absolute;top:0;`"
            v-if="width > 40"
        >
            <SurveySliderSvg v-bind="{ height, max, min, value, width }" />
        </svg>
    </div>
</template>
<script>
import SurveySliderSvg from './SurveySliderSvg.vue'

export default {
    components: { SurveySliderSvg },
    props: {
        max: {
            type: Number,
        },
        min: {
            type: Number,
        },
        value: {
            type: Number,
        },
    },
    data() {
        return {
            height: 40,
            width: 32,
        }
    },
    mounted() {
        this.domResize = new ResizeObserver(() => this.updateSize())
        this.domResize.observe(this.$el)
        this.updateSize()
    },
    beforeDestroy() {
        this.domResize?.unobserve(this.$el)
    },
    computed: {
        display() {
            if (this.value) {
                return this.value.toFixed(1)
            }
            return null
        },
    },
    methods: {
        updateSize() {
            this.$nextTick(() => (this.width = this.$el.clientWidth))
        },
    },
}
</script>
<style>
.survey-slider {
    width: 100%;
}
</style>
